<template>
  <div>
    <div v-if="meta" class="employee__filtration">
      <div class="row">
        <div class="col-sm-12">
          <Search @changeSearchParam="(value) => searchParam = value" />
        </div>
        <div class="col-sm-3">
          <span>
            {{ I18n.t('filters.show') }}
            <Filters
              :options="perPage"
              :isShowAllRecordsButtonClicked="isShowAllRecordsButtonClicked"
              @changeSelected="handleSelectChange"
              @allRecordsSelected="() => isShowAllRecordsButtonClicked = !isShowAllRecordsButtonClicked"
            />
          </span>
        </div>
        <div class="col-sm-6">
          <Pagination class="text-center" :meta="meta" />
        </div>
        <div class="col-sm-3">
          <span>
            {{I18n.t('filters.date.label')}}
            <DropdownFilter
              :options="pastBoundaryDates"
              @changeSelected="(value) => selectedPastBoundaryDate = value" />
          </span>
        </div>
      </div>
      <CheckboxFilter
        @checkboxValue="(value) => onlyUnpublished = value"
        :label="`filters.only_unpublished`"
        />
    </div>
    <div class="employee__responsive-table">
      <table class="auctions__table mt-5">
        <thead>
          <tr>
            <th>{{I18n.t("table.number")}}</th>
            <th>
              <SortLink
                :attribute="'auction_house_name'"
                :name="'auctions_catalogs.organizer'"
                @changeQ="(value) => q = value" />
            </th>
            <th>
              <SortLink
                :attribute="'name'"
                :name="'auctions_catalogs.auction_name'"
                @changeQ="(value) => q = value" />
            </th>
            <th>{{I18n.t("auctions_catalogs.city")}}</th>
            <th>
              <SortLink
                :attribute="'start_date'"
                :name="'auctions_catalogs.auction_date'"
                @changeQ="(value) => q = value" />
            </th>
            <th>
              <SortLink
                :attribute="'status'"
                :name="'auctions_catalogs.status'"
                @changeQ="(value) => q = value" />
            </th>
            <th>{{I18n.t("auctions_catalogs.notifications")}}</th>
          </tr>
        </thead>
        <tbody>
          <FinishedAuctionsCatalogsRow
            v-for="(auctionsCatalog, index) in finishedAuctionsCatalogs"
            :auctionsCatalog="auctionsCatalog"
            :address="auctionsCatalog.address"
            :auctionHouse="auctionsCatalog.auctionHouse"
            :index="parseInt(index, 10)"
            :key="index"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { FIRST_PAGE, DEFAULT_PER_PAGE } from '@/shared/consts';
  import Pagination from '@/shared/components/pagination/index';
  import SortLink from '@/shared/components/sort_link';
  import CheckboxFilter from '@/shared/components/checkbox';
  import DropdownFilter from '@/shared/components/dropdown_filter';
  import Filters from '@/shared/components/filters';
  import { PAST_BOUNDARY_DATES, PER_PAGE, SEARCH_TIMEOUT } from './../../consts';
  import FinishedAuctionsCatalogsRow from './row';
  import Search from './../search';

  export default {
    data() {
      return {
        perPage: PER_PAGE,
        pastBoundaryDates: PAST_BOUNDARY_DATES,
        selectedPerPage: DEFAULT_PER_PAGE,
        selectedPastBoundaryDate: null,
        isShowAllRecordsButtonClicked: false,
        selectedPer: DEFAULT_PER_PAGE,
        q: null,
        fetchTimeout: null,
        searchParam: '',
        onlyUnpublished: false,
      };
    },
    created() {
      this.fetchAuctionsCatalogs();
    },
    name: 'FinishedAuctionsCatalogsList',
    components: {
      FinishedAuctionsCatalogsRow,
      Pagination,
      SortLink,
      CheckboxFilter,
      DropdownFilter,
      Filters,
      Search,
    },
    watch: {
      filterParams() {
        const buildQuery = this.$route.query || {};
        buildQuery.page = FIRST_PAGE;
        this.$router.replace({ query: buildQuery });
        this.fetchAuctionsCatalogs();
      },
      currentPage() {
        this.filterParams.page = this.currentPage.page;
        this.fetchAuctionsCatalogs();
      },
      isShowAllRecordsButtonClicked(val) {
        if (val) {
          this.selectedPer = this.meta.total_count;
        } else {
          this.selectedPer = this.selectedPerPage;
        }
      },
      selectedPerPage() {
        this.selectedPer = this.selectedPerPage;
      },
    },
    computed: {
      ...mapGetters('auctionsCatalogs', ['finishedAuctionsCatalogs', 'meta']),
      filterParams() {
        return {
          per: this.selectedPer,
          past_dates_range: [this.selectedPastBoundaryDate],
          q: this.q,
          search: this.searchParam,
          unpublished: this.onlyUnpublished,
        };
      },
      currentPage() {
        return {
          page: this.$route.query.page || FIRST_PAGE,
        };
      },
    },
    methods: {
      ...mapActions('auctionsCatalogs', ['getFinishedAuctionsCatalogs']),
      fetchAuctionsCatalogs() {
        clearTimeout(this.fetchTimeout);
        this.fetchTimeout = setTimeout(() => {
          this.getFinishedAuctionsCatalogs(this.filterParams);
        }, SEARCH_TIMEOUT);
      },
      handleSelectChange(value) {
        this.selectedPerPage = value;
        this.isShowAllRecordsButtonClicked = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/list.vue?408610da